module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/mainvisual-date-pc_40526e3c6a43676a67e7de6a23e4a910.png";